import { ENDPOINTS, requestType } from "../constants/Variables";
import Api from "./index";

const createPromoCode = (_, params) => {
  return Api(ENDPOINTS.PROMO_CODE.CREATE, params, requestType.POST);
};

const getAllPromoCodes = (params) => {
  const url = ENDPOINTS.PROMO_CODE.GET_ALL;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.status) queryParams.append("status", params.status);
  if (params.startDate) queryParams.append("startDate", params.startDate);
  if (params.endDate) queryParams.append("endDate", params.endDate);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;

  return Api(finalUrl, null, requestType.GET);
};

const updatePromoCode = (id, params) => {
  return Api(
    ENDPOINTS.PROMO_CODE.UPDATE.replace(":id", id),
    params,
    requestType.PUT,
  );
};

export { createPromoCode, updatePromoCode, getAllPromoCodes };
